import { Root } from 'react-dom/client';
import { AddBizReactLoader } from '../../../Js/React/loader';
import OneEvent from './OneEvent';
import OneEvent2col from './OneEvent2col';
import EventList from './EventList';
import { withFrontendContext } from '../../Common/frontendStateContext';

let root: Root | undefined;
AddBizReactLoader(root, 'bizoneevent', (e) => {
	const params = (e.detail as { params: { eventId: number; layout?: string; tab?: string } }).params;
	if (params.layout && params.layout === '2col')
		return withFrontendContext(<OneEvent2col eventId={params.eventId} tab={params.tab} />);
	return <OneEvent eventId={params.eventId} />;
});

AddBizReactLoader(root, 'bizeventlist', (e) => {
	const params = (
		e.detail as {
			params: {
				eventFilter: string;
				desktopLayout: string;
				mobileLayout: string;
				limit: number;
				itemsPerRow: number;
				labelStyle: string;
				filters: string[];
			};
		}
	).params;

	return withFrontendContext(
		<EventList
			eventFilter={params?.eventFilter}
			desktopLayout={params?.desktopLayout || 'hero'}
			mobileLayout={params?.mobileLayout || 'carousel'}
			limit={params?.limit}
			itemsPerRow={params?.itemsPerRow}
			labelStyle={params?.labelStyle || 'default'}
			filters={params?.filters}
		/>
	);
});
